import React from 'react';
import { NavBar } from './components/NavBar';
import { Hero } from './components/Hero';
import { MilestonesStrip } from './components/MilestonesStrip';
import { FeaturedUpdate } from './components/FeaturedUpdate';
import { MapVisor } from './components/MapVisor';
import { CatastroMultiproposito } from './components/CatastroMultiproposito';
import { EscuelaIntercultural } from './components/EscuelaIntercultural';
import { AcuerdosPNN } from './components/AcuerdosPNN';
import { ColombiaEnMapas } from './components/ColombiaEnMapas';
import { DiplomadosVirtuales } from './components/DiplomadosVirtuales';
import { NewsGrid } from './components/NewsGrid';
import { ClosingCTA } from './components/ClosingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-bone text-charcoal font-sans selection:bg-clay selection:text-bone" data-id="element-0" data-mp="28u5y0mx2p5cu">
      <NavBar data-id="element-1" data-mp="23vktwcepa1j4" />
      <main data-id="element-2" data-mp="23w4e5zrtp20b">
        <Hero data-id="element-3" data-mp="23u9qidp62vsj" />
        <MilestonesStrip data-id="element-4" data-mp="23ut9zyugts8o" />
        <FeaturedUpdate data-id="element-5" data-mp="23ti7e2craqj5" />
        <MapVisor data-id="element-6" data-mp="3ikh8ubu2yx01" />
        <CatastroMultiproposito data-id="element-7" data-mp="3iiweam7rne26" />
        <AcuerdosPNN data-id="element-8" data-mp="3ijpdn24eb1aa" />
        <ColombiaEnMapas data-id="element-9" data-mp="3mlj9mx3nbh44" />
        <DiplomadosVirtuales data-id="element-10" data-mp="3ml17jjuay8oa" />
        <EscuelaIntercultural data-id="element-11" data-mp="3mjzsl4a6121a" />
        <NewsGrid data-id="element-12" data-mp="3mj6jvxrnc2gi" />
        <ClosingCTA data-id="element-13" data-mp="3rcj7c4kla37o" />
      </main>
      <Footer data-id="element-14" data-mp="3rdki07xp0nov" />
    </div>;
}